import { Expression } from "./abstract.expression";
import { UnaryExpression } from "./abstract.unary.expression";

import { Condition } from "../enums/condition";

export class BooleanExpression implements Expression
{
    constructor(
        public readonly field: string | UnaryExpression,
        public readonly operator: Condition,
        public readonly value: string | number | Date | boolean
    )
    {
        switch (operator)
        {
            case Condition.GE:
            case Condition.GT:
            case Condition.LE:
            case Condition.LT:
                if (typeof this.value !== "number" && !(this.value instanceof Date))
                {
                    throw new Error(`value must be a number or date when using conditional operator '${operator}'`);
                }
                break;
        }
    }

    toQuery(): string
    {
        const field = this.field instanceof UnaryExpression ? this.field.toQuery() : this.field;
        const value = Expression.QuoteValue(this.value);
        return `${field} ${this.operator} ${value}`;
    }
}
